import type { InputHTMLAttributes } from "react";

export function TextInput({
  className = "",
  ...props
}: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={`w-full rounded-md border border-neutral-600 bg-canvas px-2.5 py-1.5 text-sm text-neutral-100 placeholder:text-neutral-500 focus:border-teal-400 focus:outline-none ${className}`}
      {...props}
    />
  );
}
